/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
/*
Author: Gilang Romadhanu Tartila
*/

import React from 'react';
import { View, StyleSheet } from 'react-native';
import SociollaText from '@components/sociolla/SociollaText';
import { NoTranslate } from '@components/shared/TranslationContext';
import Colors from '@global/colors';
import { isWeb } from '@global/screens';
import { capitalizeText } from '@global/helpers';
import PropTypes from 'prop-types';

const propTypes = {
  newStyle: PropTypes.bool,
  status: PropTypes.string,
};

const defaultProps = {
  newStyle: false,
  status: '',
};

const StatusBadge = (props) => {
  const { status = '', newStyle = false } = props;

  let label = 'Sales Order';
  let statusBackground = '#E5E5E525';
  if (
    [
      'fully_invoiced',
      'approved',
      'delivered',
      'confirmed',
      'finished',
      'active',
      'yes',
      'posted',
      'paid',
      'submitted',
      'full',
    ].includes(status)
  ) {
    statusBackground = '#3DE96625';
  } else if (['overlimit', 'draft', 'partial'].includes(status)) {
    statusBackground = '#1E68FC25';
  } else if (['completed'].includes(status)) {
    statusBackground = '#00B5DF25';
  } else if (
    [
      'nothing_to_invoice',
      'cancelled',
      'rejected',
      'not_paid',
      'no',
      'fully_paid',
      'deleted',
    ].includes(status)
  ) {
    statusBackground = '#FC1E6825';
  } else if (['partially_paid'].includes(status)) {
    statusBackground = '#1E68FC25';
  } else if (['in_active'].includes(status)) {
    statusBackground = '#E8E8E8';
  } else if (
    ['to_confirm', 'need_approval', 'waiting_confirmation'].includes(status)
  ) {
    statusBackground = '#FCB21E25';
  } else if (
    ['quotation', 'to_invoice', 'in_progress', 'in_payment', 'joined'].includes(
      status,
    )
  ) {
    statusBackground = '#00B5DF25';
  }

  if (newStyle) {
    if (['active'].includes(status)) {
      statusBackground = '#DEF1FF';
    } else {
      statusBackground = '#EEEEEE';
    }
  }

  if (status) {
    try {
      if (
        [
          'nothing_to_invoice',
          'to_invoice',
          'fully_invoiced',
          'fully_paid',
        ].includes(status)
      ) {
        switch (status) {
          case 'nothing_to_invoice':
            label = 'No Invoice Yet';
            break;

          case 'to_invoice':
            label = 'Partially Invoiced';
            break;

          case 'fully_invoiced':
            label = 'Fully Invoiced';
            break;

          case 'fully_paid':
            label = 'Fully Paid';
            break;
        }
      } else {
        label = status.replace(/_/g, ' ');
      }
    } catch (error) {
      label = status;
    }
  }

  return (
    <View
      style={[
        styles.statusWrapper,
        { backgroundColor: statusBackground },
        newStyle ? { maxWidth: 105 } : {},
      ]}>
      <NoTranslate>
        <SociollaText
          style={{
            fontSize: 11,
            color: Colors.black,
            letterSpacing: 0.5,
          }}>
          {capitalizeText(label)}
        </SociollaText>
      </NoTranslate>
    </View>
  );
};

const styles = StyleSheet.create({
  statusWrapper: {
    position: isWeb ? 'inherit' : 'relative',
    minWidth: 105,
    paddingVertical: 6,
    paddingHorizontal: 14,
    borderRadius: 4,
    alignItems: 'center',
    ...(isWeb ? { alignSelf: 'center' } : {}),
  },
});

StatusBadge.propTypes = propTypes;
StatusBadge.defaultProps = defaultProps;

export default StatusBadge;
